import React from 'react';
import { arrayOf, func, shape, string } from 'prop-types';

import css from './KeywordList.less';

const KeywordList = ({ list, onClick }) => {
  if (list?.length === 0) return null;

  return (
    <div className={css.keywordListContainer}>
      {list.map(child => (
        <div key={child.value} className={css.keyword} onClick={() => onClick(child)}>
          {child.text}
        </div>
      ))}
    </div>
  );
};

KeywordList.propTypes = {
  list: arrayOf(
    shape({
      text: string.isRequired,
      value: string.isRequired,
    }),
  ).isRequired,
  onClick: func.isRequired,
};

export default KeywordList;
